import { useState } from "react";
import { Step1Personal } from "./step1Personal";
import { Step3Job } from "./step3Job";
import { Step2Contact } from "./step2Contact";
import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import { Step4ShiftAttendance } from "./step4Attendence";
import { Step5Payroll } from "./step5Payroll";
import { Step7SkillsAssets } from "./step7Skill";
import { Step8Emergency } from "./step8Emergency";
import { Step6KYC } from "./step6KYC";
import { Step9Review } from "./step9Review";
import { useFormContext } from "react-hook-form";
import { EmployeeFormValues } from "./formContext";
import { StepperNav } from "./stepperNav";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { stepFields } from "./stepNavigation";
import axios from "axios";

export const steps = [
  "Personal Info",
  "Contact Info",
  "Job Info",
  "Payroll",
  "Attendence",
  "Emergency",
  "Skill",
  // "KYC",
  "Review"
];

export const StepFormWrapper = ({id}:{id?:string}) => {
  const [loading,setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  // const {handleSubmit,formState: { isSubmitting },} = useForm<EmployeeFormValues>();
  const methods = useFormContext<EmployeeFormValues>();
  const {trigger,setFocus,formState:{errors}} = methods;
  const { showMessage } = useSnackbar();

  // const next = () => setActiveStep((prev) => prev + 1);
  const back = () => setActiveStep((prev) => prev - 1);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const next = async () => {
  const currentFields = stepFields[activeStep] as (keyof EmployeeFormValues)[];
  const isStepValid = await trigger(currentFields);

  console.log("current fields",currentFields)
  console.log('is valid',isStepValid)
  // helperText={(errors?.bankDetails as any)?.ifsc?.message}

  if (!isStepValid) {
    // Get first invalid field name
    const firstInvalid = currentFields.find((field) => !!errors[field]);
    console.log("first",firstInvalid);

    if (firstInvalid) setFocus(firstInvalid); // 🔍 Focus invalid field

    return; // 🔁 Stop navigation
  }

  setActiveStep((prev) => prev + 1);
};

  const onSubmit = async (data:EmployeeFormValues) => {
    console.log("data are",data)
    if (loading) return;
  setLoading(true);
    try {
      const method = id ? Method.PUTFORMDATA : Method.POST;
            const url = id
              ? `employees/update/${id}`
              : "employees/create";
      
      const formData = new FormData();

      // 🔁 Append all scalar fields
      for (const key in data) {
        const value = data[key as keyof EmployeeFormValues];

        if (
          typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean"
        ) {
          formData.append(key, String(value));
        }
      }

      // 👤 Profile photo & Offer letter;
     if (data.profilePhoto && Array.isArray(data.profilePhoto)) {
  for (const file of data.profilePhoto) {
    console.log("file",file)
    formData.append("profilePhoto", file);
  }
}

if (data.offerLetter && Array.isArray(data.offerLetter)) {
  for (const file of data.offerLetter) {
    console.log("file",file)
    formData.append("offerLetter", file);
  }
}


      // 🗂️ Resume & KYC documents
      // if (data.documents?.resume)
      //   formData.append("resume", data.documents.resume);
      // if (data.documents?.panCard?.file)
      //   formData.append("panCard", data.documents.panCard.file);
      // if (data.documents?.aadhaarCard?.file)
      //   formData.append("aadhaarCard", data.documents.aadhaarCard.file);
      // if (data.documents?.offerLetter)
      //   formData.append("offerLetter", data.documents.offerLetter);
      // formData.append("profilePhoto", data.profilePhoto);
      // formData.append('bankAccountDocument',data.documents.bankAccountDocument)
      // formData.append("resume", data.documents.resume);
      // formData.append("panCard", data.documents.panCard.file);
      // formData.append("aadhaarCard", data.documents.aadhaarCard.file);
      // formData.append("offerLetter", data.documents.offerLetter);
      

      // 🏦 Bank Details
      if (data.bankDetails) {
        formData.append("bankName", data.bankDetails.bankName);
        formData.append("accountNumber", data.bankDetails.accountNumber);
        formData.append("ifsc", data.bankDetails.ifsc);
      }

      // 💼 Experience
      if (data.experience) {
        formData.append("totalExperience", String(data.experience.totalYears));
        formData.append(
          "relevantExperience",
          String(data.experience.relevantYears)
        );
      }

      // 🆘 Emergency Contact
      if (data.emergencyContact) {
        formData.append("emergencyName", data.emergencyContact.name);
        formData.append("emergencyNumber", data.emergencyContact.number);
        formData.append(
          "emergencyRelation",
          data.emergencyContact.relationship
        );
      }

      // 🛡️ Send request
      //  const response: any = await callAPI(url, method, formData);
      const response = await axios.post(`http://https://simplestimateserver.onrender.com/api/employees/create`,formData,{headers:{"Content-Type":"multipart/form-data"},withCredentials:true})
      
            console.log("response employees", response);
      
            if (response.data?.success) {
              showMessage(response.data?.message, "success");
            }

    } catch (error:any) {
      console.error("Failed to save employee data", error);
        if (error.message === 'GlobalHandledError') return;
         showMessage(
        error?.response?.data.message || "An unexpected error occurred",
        "error"
      );
    }finally{
      setLoading(false);
    }
  };

  const onInvalid = (errors: any) => {
  console.log("Validation errors:", errors); // 👈 this will show if validation failed
};

  return (
    <form
      onSubmit={methods.handleSubmit(onSubmit,onInvalid)}
      encType="multipart/form-data"
    >
      <StepperNav activeStep={activeStep} />
      <div style={{ marginTop: 20 }}>
        {activeStep === 0 && <Step1Personal />}
        {activeStep === 1 && <Step2Contact />}
        {activeStep === 2 && <Step3Job />}
        {activeStep === 3 && <Step5Payroll />}
        {activeStep === 4 && <Step4ShiftAttendance />}
        {activeStep === 5 && <Step8Emergency />}
        {activeStep === 6 && <Step7SkillsAssets />}
        {/* {activeStep === 7 && <Step6KYC />} */}
        {activeStep === 7 && <Step9Review />}
      </div>

      <Stack
      direction={isMobile ? 'column' : 'row'}
      spacing={2}
      justifyContent="flex-end"
      mt={4}
    >
      <Button
        variant="outlined"
        onClick={back}
        disabled={activeStep === 0}
        fullWidth={isMobile}
      >
        Back
      </Button>
      <Button
  type={activeStep === steps.length - 1 ? 'submit' : 'button'}
  onClick={
    activeStep === steps.length - 1 || loading
      ? undefined
      : () => {
          if (!loading) next();
        }
  }
  variant="contained"
  fullWidth={isMobile}
  disabled={loading}
>
  {loading
    ? 'Submitting...'
    : activeStep === steps.length - 1
    ? 'Submit'
    : 'Next'}
</Button>

    </Stack>
    </form>
  );
};
